export enum IntegrationTypes {
  Csv = 'csv',
  Personio = 'personio',
  HrLab = 'hrlab',
}
